var exports = {
  "K": "xe564cbfb--942b34--image--simple",
  "f": "xe564cbfb--942b34--image--empty",
};

module.exports = exports;
